import { GlobalContext } from "../GlobalContext";

export class SetUtils {
    /**
     * Vrátí poslední objekt z předané sady. Pokud je sada prázdná vrací undefined
     * @param set Sada
     */
    public static last<R>(set: Set<R> | ReadonlySet<R>): R | undefined {
        let retValue: R | undefined = undefined;
        for (retValue of set) ;
        return retValue;
    }

    /**
     * Vrátí první objekt z předané sady. Pokud je sada prázdná vrací undefined
     * @param set Sada
     */
    public static first<R>(set: Set<R> | ReadonlySet<R>): R | undefined {
        let retValue: R | undefined = undefined;
        for (retValue of set) break;
        return retValue;
    }

    /**
     * Vrátí objekt na zadaném indexu z předané sady. Pokud je sada prázdná vrací nebo je index neplatný undefined
     * @param set Sada
     * @param index Požadovaný index
     */
    public static index<R>(set: Set<R> | ReadonlySet<R>, index: number): R | undefined {
        if (index < 0 || set.size < index) return undefined;
        let retValue: R | undefined = undefined;
        let i = 0;
        for (retValue of set) if (i++ == index) break;
        return retValue;
    }

    /**
     * Vrátí Set, jenž obsahuje objekty z obou setů
     * @param setA
     * @param setB
     * @see @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
     */
    public static union<T>(setA: Set<T>, setB: Set<T>): Set<T> {
        return new Set([...setA, ...setB]);
    }

    /**
     * Vrátí Set, jenž obsahuje totožné objekty z obou setů.
     * @param setA
     * @param setB
     * @see @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
     */
    public static intersection<T>(setA: Set<T>, setB: Set<T>): Set<T> {
        return new Set([...setA].filter(i => setB.has(i)));
    }

    /**
     * Vrátí Set, jenž obsahuje objekty z prvního setu, které nejsou v druhém
     * @param setA
     * @param setB
     * @see @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
     */
    public static difference<T>(setA: Set<T>, setB: Set<T>): Set<T> {
        const difference = new Set(setA);
        for (const elem of setB) {
            difference.delete(elem);
        }
        return difference;
    }
}

GlobalContext.registerType(SetUtils);
